const slider = new Swiper('.slider__swiper', {
    loop: true,
    slidesPerView: 1,
    effect: 'fade',
    allowTouchMove: false,
    speed: 1000,
    autoplay: {
        delay: 5000,
    },
    navigation: {
        nextEl: '.slider__swiper-button-next',
        prevEl: '.slider__swiper-button-prev',
    },
});

const categoriesSlider = new Swiper('.tiles-categories__swiper', {
    slidesPerView: 2.07,
    spaceBetween: 16,
    breakpoints: {
        768: {
            slidesPerView: 3.1,
        },
        992: {
            slidesPerView: 4,
            spaceBetween: 24,
        },
    },
});

const swiperUp = new Swiper(".heroSwiperUp", {
  direction: "vertical",
  loop: true,
  slidesPerView: 2.5,
  spaceBetween: 16,
  speed: 6000,
  allowTouchMove: false,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  }
});

const swiperDown = new Swiper(".heroSwiperDown", {
  direction: "vertical",
  loop: true,
  slidesPerView: 2.5,
  spaceBetween: 16,
  speed: 6000,
  allowTouchMove: false,
  autoplay: {
    delay: 0,
    reverseDirection: true,
    disableOnInteraction: false,
  }
});

const swiperMobile = new Swiper(".heroSwiperMobile", {
  direction: "horizontal",
  loop: true,
  slidesPerView: 1.2,
  spaceBetween: 16,
  speed: 6000,
  allowTouchMove: false,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
  breakpoints: {
    0: {
      enabled: true
    },
    992: {
      enabled: false
    }
  }
});

const animalsCarouselEl = document.querySelector('.animals-carousel__swiper');

if (animalsCarouselEl) {
  new Swiper('.animals-carousel__swiper', {
    slidesPerView: 1.3,
    loop: true,
    spaceBetween: 16,
    pagination: {
      el: '.animals-carousel__pagination',
      clickable: true,
    },
    navigation: {
      prevEl: '.animals-carousel__nav-btn--prev',
      nextEl: '.animals-carousel__nav-btn--next',
    },
    breakpoints: {
      576: {
        slidesPerView: 2.2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 3.2,
        spaceBetween: 24,
      },
      1200: {
        slidesPerView: 4.2,
        spaceBetween: 28,
      },
    },
  });
}

const galleryCarouselEl = document.querySelector('.gallery-carousel__swiper');

if (galleryCarouselEl) {
  new Swiper('.gallery-carousel__swiper', {
    slidesPerView: 1.15,
    spaceBetween: 32,
    centeredSlides: false,
    pagination: {
      el: '.gallery-carousel__pagination',
      clickable: true,
    },
    navigation: {
      prevEl: '.gallery-carousel__nav--prev',
      nextEl: '.gallery-carousel__nav--next',
    },
    breakpoints: {
      576: {
        slidesPerView: 2.15,
        spaceBetween: 20,
      },
      992: {
        slidesPerView: 3.15,
        spaceBetween: 24,
      },
    },
  });
}

const heroImgBg = document.querySelector('.h-img-bg__swiper');

if (heroImgBg) {
  const heroBgSwiper = new Swiper('.h-img-bg__swiper', {
    loop: true,
    slidesPerView: 1,
    effect: 'fade',
    speed: 1200,
    allowTouchMove: false,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    fadeEffect: {
      crossFade: true
    }
  });
}